const STORAGE_KEY = 'siagroErrors.events'
const MAX_EVENTS = 50

export const state = {
  events: getSavedState(STORAGE_KEY) || [],
}

export const getters = {
  lastEvent(state) {
    if (!Array.isArray(state.events) || !state.events.length) return null
    return state.events[0]
  },
}

export const mutations = {
  ADD_ERROR_EVENT(state, event) {
    if (!event || typeof event !== 'object') return
    const next = [event, ...(Array.isArray(state.events) ? state.events : [])].slice(0, MAX_EVENTS)
    state.events = next
    saveState(STORAGE_KEY, next)
  },
  CLEAR_ERROR_EVENTS(state) {
    state.events = []
    saveState(STORAGE_KEY, [])
  },
}

function getSavedState(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key))
  } catch (error) {
    return []
  }
}

function saveState(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    // ignore local storage failures
  }
}

